import React from "react";
import { Card, Row, Col, Table, Typography } from "antd";
import ApexCharts from "react-apexcharts";

const { Title } = Typography;

export default function SalesTrendTab({
  salesCustomerwise = [],
  salesCategorywise = [],
  salesProductCategorywise = [],
  salesStatewise = [],
  salesCustomerCategorywise = [],
}) {
  const cardStyle = {
    borderRadius: 8,
    boxShadow: "0 4px 12px rgba(0, 0, 0, 0.08)",
    backgroundColor: "#fff",
    marginBottom: 16,
  };

  const titleStyle = { fontWeight: 600, marginBottom: 12 };

  const pieChart = (labels, series) => ({
    options: {
      chart: {
        type: "donut",
        toolbar: { show: false },
        animations: {
          enabled: true,
          easing: "easeinout",
          speed: 1800,
        },
      },
      labels,
      legend: {
        position: "bottom",
        fontSize: "11px",
        fontWeight: 400,
        itemMargin: { horizontal: 4, vertical: 2 },
      },
      dataLabels: {
        enabled: true,
        style: {
          fontSize: "11px",
          // fontWeight: "bold",
          colors: ["#fff"],
        },
        dropShadow: {
          enabled: false,
          top: 1,
          left: 1,
          blur: 2,
          // opacity: 0.7,
        },
      },
      tooltip: {
        y: {
          formatter: (val) => val.toLocaleString("en-IN"),
          style: {
            fontSize: "14px",
          },
        },
      },
      colors: ["#1976d2", "#d32f2f", "#388e3c", "#fbc02d", "#7b1fa2", "#0097a7", "#f57c00"],
      fill: {
        type: "gradient",
      },
      plotOptions: {
        pie: {
          donut: {
            size: "60%",
            labels: {
              show: true,
              name: {
                show: true,
                fontSize: "14px",
                fontWeight: 600,
                color: "#333",
              },
              value: {
                show: true,
                fontSize: "13px",
                fontWeight: 700,
                color: "#111",
                formatter: (val) => val.toLocaleString("en-IN"),
              },
              total: {
                show: true,
                label: "Total",
                fontSize: "13px",
                fontWeight: 700,
                color: "#000",
                formatter: () =>
                  series.reduce((acc, cur) => acc + cur, 0).toLocaleString("en-IN"),
              },
            },
          },
        },
      },
      responsive: [
        {
          breakpoint: 768,
          options: {
            chart: { height: 280 },
            legend: { position: "bottom" },
          },
        },
      ],
    },
    series,
  });
  ;

  const tables = [
    {
      title: "Customer Wise Sales Qty & Value", data: salesCustomerwise, columns: [
        { title: "Customer Name", dataIndex: "CustomerName", key: "CustomerName" },
        { title: "Qty", dataIndex: "Qty", key: "Qty", align: "right" },
        { title: "Value", dataIndex: "Value", key: "Value", align: "right", render: (val) => Number(val).toLocaleString("en-IN"), },
      ]
    },
    {
      title: "Category Wise Sales Qty & Value", data: salesCategorywise, columns: [
        { title: "Sub Group Level", dataIndex: "SubGroup_CategoryName", key: "SubGroup_CategoryName" },
        { title: "Qty", dataIndex: "Qty", key: "Qty", align: "right" },
        { title: "Value", dataIndex: "Value", key: "Value", align: "right", render: (val) => Number(val).toLocaleString("en-IN"), },
      ]
    },
    {
      title: "Product Category Wise Sales Qty & Value", data: salesProductCategorywise, columns: [
        { title: "Product Category", dataIndex: "ProductCategory_ItemName", key: "ProductCategory_ItemName" },
        { title: "Qty", dataIndex: "Qty", key: "Qty", align: "right" },
        { title: "Value", dataIndex: "Value", key: "Value", align: "right", render: (val) => Number(val).toLocaleString("en-IN"), },
      ]
    },
    {
      title: "State Wise Sales Qty & Value", data: salesStatewise, columns: [
        { title: "State Code", dataIndex: "StateCode", key: "StateCode" },
        { title: "Qty", dataIndex: "Qty", key: "Qty", align: "right" },
        { title: "Value", dataIndex: "Value", key: "Value", align: "right", render: (val) => Number(val).toLocaleString("en-IN"), },
      ]
    },
    {
      title: "Customer Category Wise Sales Qty & Value", data: salesCustomerCategorywise, columns: [
        { title: "Category", dataIndex: "Category", key: "Category" },
        { title: "Qty", dataIndex: "Qty", key: "Qty", align: "right" },
        { title: "Value", dataIndex: "Value", key: "Value", align: "right", render: (val) => Number(val).toLocaleString("en-IN"), },
      ]
    },
  ];

  const pieData = [
    {
      label: "Category Wise Sales %",
      labels: salesCategorywise.map(i =>
        i.SubGroup_CategoryName ? i.SubGroup_CategoryName : "Uncategorized"
      ),
      series: salesCategorywise.map(i => Number(i.Value) || 0),
    },
  ];
  return (
    <div className="sales-trend-tab" style={{ padding: 16 }}>
      <Row gutter={[16, 16]} style={{ marginTop: 12 }}>
        {pieData.map((pie, idx) => (
          <Col xs={24} md={12} key={idx}>
            <Card title={<Title level={5} style={{ ...titleStyle, color: "#1565c0" }}>{pie.label}</Title>} style={cardStyle} bodyStyle={{ padding: 12 }}>
              <ApexCharts options={pieChart(pie.labels, pie.series).options} series={pie.series} type="donut" height={420} />
            </Card>
          </Col>
        ))}
        {tables.map((tbl, i) => (
          <Col xs={24} md={12} key={i}>
            <Card title={<Title level={5} style={{ ...titleStyle, color: "#c62828" }}>{tbl.title}</Title>} style={cardStyle} bodyStyle={{ padding: 12 }}>
              <Table
                columns={tbl.columns}
                dataSource={tbl.data}
                size="small"
                pagination={{pageSize: 10}}
                bordered
                scroll={{ x: 400, y: 500 }}
                rowKey={(r, idx) => `${tbl.title}-${idx}`}
                summary={pageData => {
                  let totalQty = 0;
                  let totalValue = 0;
                  pageData.forEach(({ Qty, Value }) => {
                    totalQty += Number(Qty) || 0;
                    totalValue += Number(Value) || 0;
                  });
                  return (
                    <Table.Summary.Row>
                      <Table.Summary.Cell><b>Grand Total</b></Table.Summary.Cell>
                      <Table.Summary.Cell align="right"><b>{totalQty.toLocaleString()}</b></Table.Summary.Cell>
                      <Table.Summary.Cell align="right"><b>{totalValue.toLocaleString()}</b></Table.Summary.Cell>
                    </Table.Summary.Row>
                  );
                }}
              />
            </Card>
          </Col>
        ))}
      </Row>
    </div>
  );
}
